/**
 * 売却査定・運用相談フォーム
 */
const consultationPage = () => {
    if (document.body.id !== 'page-consultation') return;

    const estateBodyRow = document.querySelector('.js-estate-body-row');
    if (!estateBodyRow) return;

    // 初期状態を設定
    const updateEstateBodyVisibility = () => {
        const checked = document.querySelector('input[name="estate_type"]:checked');
        const isOther = checked?.value === 'other';
        estateBodyRow.style.display = isOther ? '' : 'none';
    };

    // ラジオボタンの変更を監視
    document.querySelectorAll('input[name="estate_type"]').forEach((radio) => {
        radio.addEventListener('change', updateEstateBodyVisibility);
    });

    updateEstateBodyVisibility();
};

export default consultationPage;
